import React, { useMemo } from 'react';
import { useLocationBasedPhoneNumber } from '../../hooks/useLocationBasedPhoneNumber';

/**
 * Component that renders a phone link with location-based phone number
 * Shows Ottawa phone number for users within 50km of Ottawa, default number otherwise
 */
const LocationBasedPhoneLink = ({
    className,
    children,
    showNumber = true,
    defaultPhoneNumber
}) => {
    const phoneNumber = useLocationBasedPhoneNumber(defaultPhoneNumber);

    // Memoize the href to prevent unnecessary re-renders
    const href = useMemo(() => `tel:${phoneNumber}`, [phoneNumber]);

    return (
        <a href={href} className={className}>
            {children}
            {showNumber && ` ${phoneNumber}`}
        </a>
    );
};

export default LocationBasedPhoneLink;
